import { ReactNode } from "react";

import bridge from "@/../../hypetrain/static/img/about-bridge.jpg";
import compass from "@/../../hypetrain/static/img/about-compass.jpg";
import forest from "@/../../hypetrain/static/img/about-forest.jpg";
import rocket from "@/../../hypetrain/static/img/about-rocket.jpg";
import { Box, Flex } from "@/components/layout/flexbox";
import { Container } from "@/components/pieces/bootstrap";
import {
  StyledSubtitle,
  StyledTitle,
} from "@/components/pieces/marketing/Titles";
import { HEADING_FONT } from "@/css/constants";

interface PrincipleProps {
  img: string;
  title: string;
  desc: ReactNode;
}

function Principle({ img, title, desc }: PrincipleProps) {
  return (
    <Box
      backgroundColor="#F6F6FB"
      className="round-corners"
      pt={10}
      textAlign="center"
      width={["100%", "45%"]}
      flex="1 1 auto"
    >
      <img src={img} className="inline-block" />
      <Box p={18} pb={24}>
        <Box mt={2} fontSize={24} fontFamily={HEADING_FONT}>
          {title}
        </Box>
        <Box mt={2} fontSize={18}>
          {desc}
        </Box>
      </Box>
    </Box>
  );
}

export function Principles() {
  return (
    <Box backgroundColor="#FFF" py={90}>
      <Container className="!max-w-marketing-content">
        <Flex flexDirection="column" alignItems="center">
          <Box>
            <StyledTitle>Our Guiding Principles</StyledTitle>
            <StyledSubtitle>
              Our principles keep us grounded in an ever-changing world
            </StyledSubtitle>
          </Box>
          <Flex
            style={{ gap: 24 }}
            mt={4}
            flexWrap={["wrap", "wrap", "nowrap"]}
          >
            <Principle
              img={forest}
              title="Client Obsession"
              desc="We exist to help our clients achieve their goals – both organizations and their employees. We always optimize for our clients' success."
            />

            <Principle
              img={compass}
              title="Act With Integrity"
              desc={
                <>
                  We do the right thing <i>because</i> it's the right thing.
                  Excellence demands integrity, which is why it's
                  non-negotiable.
                </>
              }
            />
            <Principle
              img={rocket}
              title="Relentless Improvement"
              desc="Excellence is a journey, not a destination. We believe that mastery comes from the daily commitment to be better than yesterday—in our platform, our service, and ourselves."
            />
            <Principle
              img={bridge}
              title="Practice Candor"
              desc="We practice candor, which means caring personally about each other and addressing issues directly. Excellence requires honest feedback and the courage to receive it."
            />
          </Flex>
        </Flex>
      </Container>
    </Box>
  );
}
